import PeriodosIndexPage from "@/Pages/PreMatriculas/Periodos/index.vue";
import NewEditPeriodoPage from "@/Pages/PreMatriculas/Periodos/NewEditPeriodoPage.vue";
import PreMatriculasIndexPage from "@/Pages/PreMatriculas/index.vue";
import EntradaPage from "@/Pages/PreMatriculas/Publico/EntradaPage.vue";
import FormularioPage from "@/Pages/PreMatriculas/Publico/FormularioPage.vue";
import BoletoPage from "@/Pages/PreMatriculas/Publico/BoletoPage.vue";
import temPermissao from "./guards/temPermissao";

const exigir = (permissoes) => (to, from, next) => {
  if (!temPermissao(permissoes, to, from, next)) return;
  next();
};

export default [
  // Administração: períodos de pré-matrícula
  {
    path: "/pre-matricula-periodos",
    name: "preMatriculaPeriodos",
    component: PeriodosIndexPage,
    beforeEnter: exigir(["preMatriculaPeriodos.listar", "preMatriculaPeriodos.*"]),
  },
  {
    path: "/pre-matricula-periodos/create",
    name: "preMatriculaPeriodos.create",
    component: NewEditPeriodoPage,
    props: { editing: false },
    beforeEnter: exigir(["preMatriculaPeriodos.criar", "preMatriculaPeriodos.*"]),
  },
  {
    path: "/pre-matricula-periodos/edit/:periodo_id",
    name: "preMatriculaPeriodos.edit",
    component: NewEditPeriodoPage,
    props: { editing: true },
    beforeEnter: exigir(["preMatriculaPeriodos.listar", "preMatriculaPeriodos.*"]),
  },

  // Secretaria: acompanhamento e efetivação
  {
    path: "/pre-matriculas",
    name: "preMatriculas",
    component: PreMatriculasIndexPage,
    beforeEnter: exigir(["preMatriculas.listar", "preMatriculas.*"]),
  },

  // Fluxo público, sem login. Os nomes estão em `rotasPublicas` no router/index.js.
  {
    path: "/pre-matricula",
    name: "preMatricula.entrada",
    component: EntradaPage,
  },
  {
    path: "/pre-matricula/formulario",
    name: "preMatricula.formulario",
    component: FormularioPage,
  },
  {
    path: "/pre-matricula/boleto",
    name: "preMatricula.boleto",
    component: BoletoPage,
  },
];
